import packageJson from "../../package.json";
import React, { ReactNode } from "react";
import { useSidebar } from "../components/ui/sidebar";

const dependencies = packageJson?.dependencies as
    | Record<string, string>
    | undefined;
const rkVersion = dependencies?.["rk-react-component"]?.replace(/^[\^~]/, "");
const appVersion = process.env.REACT_APP_RELEASE;

export const FooterLayout = (): ReactNode => {
    const { state } = useSidebar();
    const collapsed = state === "collapsed";

    if (collapsed) {
        return (
            <div className="flex items-center justify-center p-4 border-t border-sidebar-border w-full">
                <span className="text-[10px] font-semibold tracking-wide text-sidebar-foreground/60">
                    v{appVersion}
                </span>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center gap-1 p-4 border-t border-sidebar-border w-full">
            <div className="flex items-center gap-1.5 text-xs font-semibold text-sidebar-foreground/80">
                <span className="h-1.5 w-1.5 rounded-full bg-sidebar-primary" />
                Dream Book
            </div>
            <span className="text-[10px] font-medium tracking-wide text-sidebar-foreground/60">
                v{appVersion}
                {rkVersion ? ` · RK ${rkVersion}` : ""}
            </span>
        </div>
    );
};
